<template>
  <div class="main-text-container">
    <div>欢迎使用业务管理平台</div>
  </div>
</template>

<script>
export default {
  name: 'WXAuth',
  data() {
    return {
      corpId: "wwf64ff6d5df4d651b",
      redirectUri: encodeURIComponent("https://dip.sylvoxtv.com/callback"),
      //redirectUri: encodeURIComponent("http://diwviq.natappfree.cc/callback"),
      state: "kontech", // 可以是任意值，用于防止CSRF攻击
      agentId: "1000016",
    };
  },
  computed: {
    loginUrl() {
      return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.corpId}&redirect_uri=${this.redirectUri}&response_type=code&scope=snsapi_base&state=${this.stage}&agentid=${this.agentId}#wechat_redirect`;
    },
  },
  async beforeMount() {
    const token = localStorage.getItem("token");
    if (token) {
      this.$router.push("/");
    }else{
      window.location.href = this.loginUrl;
    }
  },

};
</script>
<style scoped>
.main-text-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 100vh; /* 使容器高度为视口高度 */
}
a {
  text-decoration: none;
  color: blue;
}
</style>
